import React, { useState, useEffect } from 'react';

const YELLOW = '#FFED29';
const BLACK = '#1a1a1a';
const DARK_GRAY = '#2d2d2d';
const WHITE = '#ffffff';
const BEIGE = '#f5f1e8';

const Kontakt = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  // ---- TikTok Pixel Code ----
  useEffect(() => {
    // Check if TikTok pixel is already loaded
    if (window.ttq) return;

    const t = 'ttq';
    window.TiktokAnalyticsObject = t;
    const ttq = window[t] = window[t] || [];
    
    ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie", "holdConsent", "revokeConsent", "grantConsent"];
    
    ttq.setAndDefer = function (target, method) {
      target[method] = function () {
        target.push([method].concat(Array.prototype.slice.call(arguments, 0)));
      };
    };
    
    for (let i = 0; i < ttq.methods.length; i++) {
      ttq.setAndDefer(ttq, ttq.methods[i]);
    }
    
    ttq.instance = function (id) {
      const instance = ttq._i[id] || [];
      for (let n = 0; n < ttq.methods.length; n++) {
        ttq.setAndDefer(instance, ttq.methods[n]);
      }
      return instance;
    };
    
    ttq.load = function (pixelId, options) {
      const scriptUrl = "https://analytics.tiktok.com/i18n/pixel/events.js";
      ttq._i = ttq._i || {};
      ttq._i[pixelId] = [];
      ttq._i[pixelId]._u = scriptUrl;
      ttq._t = ttq._t || {};
      ttq._t[pixelId] = +new Date();
      ttq._o = ttq._o || {};
      ttq._o[pixelId] = options || {};
      
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.async = true;
      script.src = scriptUrl + "?sdkid=" + pixelId + "&lib=" + t;
      const firstScript = document.getElementsByTagName("script")[0];
      firstScript.parentNode.insertBefore(script, firstScript);
    };

    ttq.load('D4E3333C77UF4SPAJ6OG');
    ttq.page();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    // Your EmailJS credentials
    const SERVICE_ID = 'service_5xh67ud';
    const TEMPLATE_ID = 'template_ea3zx4i';
    const PUBLIC_KEY = 'SOPNynNB_nnCOd8Rs';

    try {
      const response = await fetch('https://api.emailjs.com/api/v1.0/email/send', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          service_id: SERVICE_ID,
          template_id: TEMPLATE_ID,
          user_id: PUBLIC_KEY,
          template_params: {
            name: formData.name,
            email: formData.email,
            phone: formData.phone || 'Nicht angegeben',
            message: formData.message,
          }
        })
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', phone: '', message: '' });
        setTimeout(() => setSubmitStatus(null), 5000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <>
      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { 
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", sans-serif;
        }
        
        @media (max-width: 968px) {
          .contact-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>

      <div style={{
        backgroundColor: WHITE,
        minHeight: '100vh'
      }}>
        
        {/* Hero Section */}
        <div style={{
          position: 'relative',
          padding: '150px 40px',
          textAlign: 'center',
          overflow: 'hidden'
        }}>
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("/Selection (3).png")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            zIndex: 1
          }} />
          
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(to bottom, rgba(0,0,0,0.4), rgba(0,0,0,0.6))',
            zIndex: 2
          }} />
          
          <div style={{
            position: 'relative',
            zIndex: 3
          }}>
            <h1 style={{
              fontSize: '3.5rem',
              fontWeight: 900,
              color: WHITE,
              marginBottom: '20px',
              letterSpacing: '-1px',
              textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
            }}>
              Kontaktiere <span style={{ color: YELLOW }}>uns</span>
            </h1>
            <p style={{
              fontSize: '1.2rem',
              color: WHITE,
              maxWidth: '700px',
              margin: '0 auto',
              lineHeight: 1.6,
              textShadow: '1px 1px 3px rgba(0,0,0,0.5)'
            }}>
              Wir sind für dich da – telefonisch, per E-Mail oder direkt vor Ort.
            </p>
          </div>
        </div>

        {/* Contact Info & Form Section */}
        <section style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '80px 40px',
          backgroundColor: WHITE
        }}>
          <div className="contact-grid" style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '50px',
            alignItems: 'start'
          }}>
            
            {/* Left Column - Contact Information */}
            <div>
              <h2 style={{
                fontSize: '2rem',
                fontWeight: '700',
                color: BLACK,
                marginBottom: '30px',
                letterSpacing: '-0.5px'
              }}>
                Kontaktinformationen
              </h2>

              {/* Address */}
              <div style={{
                backgroundColor: '#f8f8f8',
                padding: '25px',
                marginBottom: '20px',
                display: 'flex',
                gap: '20px',
                transition: 'all 0.3s ease',
                borderLeft: `4px solid ${YELLOW}`
              }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#f8f8f8'}>
                <div style={{
                  width: '50px',
                  height: '50px',
                  backgroundColor: YELLOW,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  <svg style={{ width: '24px', height: '24px', fill: BLACK }} viewBox="0 0 24 24">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                  </svg>
                </div>
                <div>
                  <h3 style={{
                    fontSize: '0.85rem',
                    color: '#666',
                    marginBottom: '8px',
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                    fontWeight: 600
                  }}>Adresse</h3>
                  <p style={{
                    fontSize: '1rem',
                    color: BLACK,
                    lineHeight: 1.6
                  }}>
                    Küvenkamp 3<br/>
                    46509 Xanten<br/>
                    Deutschland
                  </p>
                </div>
              </div>

              {/* Phone */}
              <div style={{
                backgroundColor: '#f8f8f8',
                padding: '25px',
                marginBottom: '20px',
                display: 'flex',
                gap: '20px',
                transition: 'all 0.3s ease',
                borderLeft: `4px solid ${YELLOW}`
              }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#f8f8f8'}>
                <div style={{
                  width: '50px',
                  height: '50px',
                  backgroundColor: YELLOW,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  <svg style={{ width: '24px', height: '24px', fill: BLACK }} viewBox="0 0 24 24">
                    <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
                  </svg>
                </div>
                <div>
                  <h3 style={{
                    fontSize: '0.85rem',
                    color: '#666',
                    marginBottom: '8px',
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                    fontWeight: 600
                  }}>Telefon</h3>
                  <a href="tel:+4928019856340" style={{
                    fontSize: '1rem',
                    color: BLACK,
                    textDecoration: 'none',
                    display: 'block',
                    marginBottom: '6px',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.color = YELLOW}
                  onMouseLeave={(e) => e.target.style.color = BLACK}>
                    +49 2801 9856340
                  </a>
                  <a href="tel:+4915560524486" style={{
                    fontSize: '1rem',
                    color: BLACK,
                    textDecoration: 'none',
                    display: 'block',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.color = YELLOW}
                  onMouseLeave={(e) => e.target.style.color = BLACK}>
                    +49 1556 0524486
                  </a>
                </div>
              </div>

              {/* Email */}
              <div style={{
                backgroundColor: '#f8f8f8',
                padding: '25px',
                marginBottom: '20px',
                display: 'flex',
                gap: '20px',
                transition: 'all 0.3s ease',
                borderLeft: `4px solid ${YELLOW}`
              }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#f8f8f8'}>
                <div style={{
                  width: '50px',
                  height: '50px',
                  backgroundColor: YELLOW,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  <svg style={{ width: '24px', height: '24px', fill: BLACK }} viewBox="0 0 24 24">
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                  </svg>
                </div>
                <div>
                  <h3 style={{
                    fontSize: '0.85rem',
                    color: '#666',
                    marginBottom: '8px',
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                    fontWeight: 600
                  }}>E-Mail</h3>
                  <a href="mailto:info@autoshobbywerkstatt.de" style={{
                    fontSize: '1rem',
                    color: BLACK,
                    textDecoration: 'none',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.color = YELLOW}
                  onMouseLeave={(e) => e.target.style.color = BLACK}>
                    info@autoshobbywerkstatt.de
                  </a>
                </div>
              </div>

              {/* Opening Hours */}
              <div style={{
                backgroundColor: '#f8f8f8',
                padding: '25px',
                display: 'flex',
                gap: '20px',
                transition: 'all 0.3s ease',
                borderLeft: `4px solid ${YELLOW}`
              }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#f8f8f8'}>
                <div style={{
                  width: '50px',
                  height: '50px',
                  backgroundColor: YELLOW,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  <svg style={{ width: '24px', height: '24px', fill: BLACK }} viewBox="0 0 24 24">
                    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
                    <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
                  </svg>
                </div>
                <div style={{ flex: 1 }}>
                  <h3 style={{
                    fontSize: '0.85rem',
                    color: '#666',
                    marginBottom: '12px',
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                    fontWeight: 600
                  }}>Öffnungszeiten</h3>
                  <div style={{ fontSize: '0.95rem', lineHeight: 1.8 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                      <span style={{ color: '#666' }}>Mo – Su:</span>
                      <span style={{ color: BLACK, fontWeight: 600 }}>09:00 – 18:00</span>
                    </div>
                   
                    
                    
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column - Contact Form */}
            <div>
              <h2 style={{
                fontSize: '2rem',
                fontWeight: '700',
                color: BLACK,
                marginBottom: '30px',
                letterSpacing: '-0.5px'
              }}>
                Schreib uns eine Nachricht
              </h2>

              <div style={{
                backgroundColor: '#f8f8f8',
                padding: '35px',
                borderLeft: `4px solid ${YELLOW}`
              }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                  <div>
                    <label style={{
                      display: 'block',
                      fontSize: '0.85rem',
                      color: '#666',
                      marginBottom: '8px',
                      textTransform: 'uppercase',
                      letterSpacing: '1px',
                      fontWeight: 600
                    }}>Name *</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      style={{
                        width: '100%',
                        padding: '12px',
                        backgroundColor: WHITE,
                        border: '2px solid #ddd',
                        color: BLACK,
                        fontSize: '1rem',
                        outline: 'none',
                        transition: 'all 0.3s ease'
                      }}
                      onFocus={(e) => e.target.style.borderColor = YELLOW}
                      onBlur={(e) => e.target.style.borderColor = '#ddd'}
                    />
                  </div>

                  <div>
                    <label style={{
                      display: 'block',
                      fontSize: '0.85rem',
                      color: '#666',
                      marginBottom: '8px',
                      textTransform: 'uppercase',
                      letterSpacing: '1px',
                      fontWeight: 600
                    }}>E-Mail-Adresse *</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      style={{
                        width: '100%',
                        padding: '12px',
                        backgroundColor: WHITE,
                        border: '2px solid #ddd',
                        color: BLACK,
                        fontSize: '1rem',
                        outline: 'none',
                        transition: 'all 0.3s ease'
                      }}
                      onFocus={(e) => e.target.style.borderColor = YELLOW}
                      onBlur={(e) => e.target.style.borderColor = '#ddd'}
                    />
                  </div>

                  <div>
                    <label style={{
                      display: 'block',
                      fontSize: '0.85rem',
                      color: '#666',
                      marginBottom: '8px',
                      textTransform: 'uppercase',
                      letterSpacing: '1px',
                      fontWeight: 600
                    }}>Telefonnummer (optional)</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      style={{
                        width: '100%',
                        padding: '12px',
                        backgroundColor: WHITE,
                        border: '2px solid #ddd',
                        color: BLACK,
                        fontSize: '1rem',
                        outline: 'none',
                        transition: 'all 0.3s ease'
                      }}
                      onFocus={(e) => e.target.style.borderColor = YELLOW}
                      onBlur={(e) => e.target.style.borderColor = '#ddd'}
                    />
                  </div>

                  <div>
                    <label style={{
                      display: 'block',
                      fontSize: '0.85rem',
                      color: '#666',
                      marginBottom: '8px',
                      textTransform: 'uppercase',
                      letterSpacing: '1px',
                      fontWeight: 600
                    }}>Nachricht *</label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows="5"
                      style={{
                        width: '100%',
                        padding: '12px',
                        backgroundColor: WHITE,
                        border: '2px solid #ddd',
                        color: BLACK,
                        fontSize: '1rem',
                        outline: 'none',
                        resize: 'vertical',
                        fontFamily: 'inherit',
                        transition: 'all 0.3s ease'
                      }}
                      onFocus={(e) => e.target.style.borderColor = YELLOW}
                      onBlur={(e) => e.target.style.borderColor = '#ddd'}
                    />
                  </div>

                  <button
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                    style={{
                      backgroundColor: isSubmitting ? '#ccc' : YELLOW,
                      color: BLACK,
                      border: 'none',
                      padding: '15px 35px',
                      fontSize: '0.9rem',
                      fontWeight: '700',
                      letterSpacing: '1px',
                      textTransform: 'uppercase',
                      cursor: isSubmitting ? 'not-allowed' : 'pointer',
                      transition: 'all 0.3s ease',
                      width: '100%'
                    }}
                    onMouseEnter={(e) => {
                      if (!isSubmitting) {
                        e.target.style.backgroundColor = '#FFE600';
                        e.target.style.transform = 'translateY(-2px)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isSubmitting) {
                        e.target.style.backgroundColor = YELLOW;
                        e.target.style.transform = 'translateY(0)';
                      }
                    }}
                  >
                    {isSubmitting ? 'Wird gesendet...' : 'Nachricht senden'}
                  </button>

                  {submitStatus === 'success' && (
                    <div style={{
                      padding: '12px',
                      backgroundColor: '#d4edda',
                      color: '#155724',
                      borderLeft: `4px solid #28a745`,
                      fontSize: '0.9rem'
                    }}>
                      ✓ Nachricht erfolgreich gesendet! Wir melden uns bald bei Ihnen.
                    </div>
                  )}

                  {submitStatus === 'error' && (
                    <div style={{
                      padding: '12px',
                      backgroundColor: '#f8d7da',
                      color: '#721c24',
                      borderLeft: `4px solid #dc3545`,
                      fontSize: '0.9rem'
                    }}>
                      ✗ Fehler beim Senden. Bitte versuchen Sie es später erneut.
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Map Section */}
        <section style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '80px 40px',
          backgroundColor: BEIGE
        }}>
          <h2 style={{
            fontSize: '2rem',
            fontWeight: '700',
            color: BLACK,
            marginBottom: '30px',
            letterSpacing: '-0.5px',
            textAlign: 'center'
          }}>
            Hier findest du uns
          </h2>

          <div style={{
            overflow: 'hidden',
            marginBottom: '20px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
          }}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2482.3845799999997!2d6.449628!3d51.6622!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47b8f1e7a7a7a7a7%3A0x1234567890abcdef!2sK%C3%BCvenkamp%203%2C%2046509%20Xanten!5e0!3m2!1sde!2sde!4v1234567890123"
              width="100%"
              height="400"
              style={{ border: 0, display: 'block' }}
              allowFullScreen=""
              loading="lazy"
              title="Google Maps Location"
            />
          </div>

          <p style={{
            textAlign: 'center',
            fontSize: '0.95rem',
            color: '#666',
            fontStyle: 'italic'
          }}>
            📍 Parkplätze sind direkt vor der Halle vorhanden.
          </p>
        </section>

      </div>
    </>
  );
};

export default Kontakt;